<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link :to="{name: 'forum', params: {id: 1}}"
  >{{$t('news.template.proposal.riksdagenDecision.p1')}}</router-link>
  {{$t('news.template.proposal.riksdagenDecision.p2')}}
  {{news.textParams[0]}}
  {{$t('news.template.proposal.riksdagenDecision.p3')}}
  <router-link :to="{name: 'ProposalView', params: {id: news.textParams[1]}}">
    {{news.textParams[2]}}
  </router-link>
  {{$t('news.template.proposal.riksdagenDecision.p4')}}
  <a href="#">
    {{$t('news.template.proposal.riksdagenDecision.p5')}}
  </a>.
</div>
</template>
